import { render, staticRenderFns } from "./AboutUsSettingsPage.vue?vue&type=template&id=23648b34&scoped=true"
import script from "./AboutUsSettingsPage.vue?vue&type=script&lang=js"
export * from "./AboutUsSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23648b34",
  null
  
)

export default component.exports